import axios, { AxiosError } from "axios";
import { DynamicText, DynamicTextDomainResponse } from "../models/dynamic-text";
import { dynamicTextDomainApiHost } from "../util/constants";

type Args = {
  experience: string;
  page: string;
};

export async function getDynamicText({
  experience,
  page,
}: Args): Promise<DynamicText> {
  const dynamicTextDomainApiUrl = `${dynamicTextDomainApiHost}/experience-dynamic-text/v1/${experience}/${page}`;
  const accessToken = localStorage.getItem("oktaToken");

  if (!accessToken) {
    console.log(`Missing access token for Dynamic Text Domain API request.`);
    throw new Error();
  }

  try {
    const { data, headers } = await axios.get<DynamicTextDomainResponse | string>(dynamicTextDomainApiUrl,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const traceId = headers?.["x-amzn-trace-id"] || "missing";
    const resolved: DynamicText =
      typeof data === "string"
        ? { disclosureText: data, complianceNumber: "" }
        : resolveDynamicText(data, traceId);

    return resolved;
  } catch (error) {
    const traceId =
      (error as AxiosError)?.response?.headers?.["x-amzn-trace-id"] ||
      "missing";
    console.log(`Dynamic Text Domain API request failed:`, error, `Trace ID: ${traceId}`);
    throw new Error();
  }
}


export function resolveDynamicText(
  data: DynamicTextDomainResponse,
  traceId: string
): DynamicText {
  const disclosureText = data?.fields?.genericDisclosure || "";
  const complianceNumber = data?.complianceNumber?.trim() || "";

  if (!disclosureText) {
    console.log(`Dynamic text domain generic disclosure is missing. Trace ID: ${traceId}`);
    throw new Error();
  }

  return { disclosureText, complianceNumber };
}
